import { motion } from "framer-motion";
import { PencilRuler, Gauge, Handshake, ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/api";

const STEPS = [
  { icon: PencilRuler, n: "01", title: "Zadajte rozmery alebo nahrajte projekt", desc: "Jednoduchý formulár, alebo nahrajte projektovú dokumentáciu — cenu odhadneme aj z nej.",
    img: "https://images.unsplash.com/photo-1542621334-a254cf47733d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { icon: Gauge, n: "02", title: "Získajte cenu do 60 sekúnd", desc: "Materiál, práca, lešenie aj doprava — transparentný orientačný rozpočet okamžite.",
    img: "https://images.pexels.com/photos/5563414/pexels-photo-5563414.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800" },
  { icon: Handshake, n: "03", title: "Spojíme vás s overeným realizátorom", desc: "V každom okrese máme preverených partnerov so zárukou 36 mesiacov na prácu a 60 mesiacov na materiál.",
    img: "https://images.unsplash.com/photo-1661684631842-6ab0a828468f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
];

export function HowItWorks() {
  return (
    <section id="ako-to-funguje" className="bg-ink-2 py-24 md:py-32 border-t border-white/10" data-testid="how-it-works">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div className="max-w-2xl">
            <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-5">Ako to funguje</p>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.9] text-white">Tri kroky<br /><span className="text-gold">k vášmu zatepleniu</span></h2>
          </div>
          <button onClick={() => scrollToId("#kalkulacka")} data-testid="how-it-works-cta"
            className="group self-start md:self-end bg-gold text-ink px-7 py-4 font-bold uppercase tracking-wider text-sm flex items-center gap-3 hover:bg-gold-light transition-colors">
            Začať teraz <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div key={s.n} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12 }}
                className="group relative overflow-hidden border border-white/10 bg-ink p-8 min-h-[300px] flex flex-col justify-end hover:border-gold/40 transition-colors">
                {/* background image + gradient */}
                <img src={s.img} alt={s.title} loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-45 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/90 to-ink/50" />
                {/* content */}
                <div className="relative z-10">
                  <div className="font-display text-6xl text-white/10 absolute -top-2 right-0 select-none">{s.n}</div>
                  <Icon className="w-9 h-9 text-gold mb-6" />
                  <h3 className="text-white text-lg font-semibold leading-snug mb-3">{s.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
